<template>
    <v-app>
        <v-container fluid>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-alert color="blue-grey" dark dense icon="mdi-cloud-alert" prominent>
                        <v-row align="center">
                            <v-col class="grow"> Page Not found </v-col>
                            <v-col class="shrink">
                                <v-btn href="/">Take Me Home</v-btn>
                            </v-col>
                        </v-row>
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>
<script>
export default {
    name: "NotFound",
};
</script>
